import * as R from 'ramda'

//noinspection JSUnusedGlobalSymbols
export default {

    all: state => R.values(state.entities),

    allByCountryId: (state, getters) => countryId => {
        return R.filter(R.propEq('country', countryId), getters['all'])
    },

    byId: state => id => {
        return state.entities[id]
    }

}


